export const ANALYSIS_PROPERTIES_REQUEST = 'ANALYSIS_PROPERTIES_REQUEST'
export const ANALYSIS_PROPERTIES_SUCCESS = 'ANALYSIS_PROPERTIES_SUCCESS'
export const ANALYSIS_PROPERTIES_FAIL = 'ANALYSIS_PROPERTIES_FAIL'

export const ANALYSIS_PROPERTIES_CLIENT_REQUEST =
  'ANALYSIS_PROPERTIES_CLIENT_REQUEST'
export const ANALYSIS_PROPERTIES_CLIENT_SUCCESS =
  'ANALYSIS_PROPERTIES_CLIENT_SUCCESS'
export const ANALYSIS_PROPERTIES_CLIENT_FAIL = 'ANALYSIS_PROPERTIES_CLIENT_FAIL'

export const ANALYSIS_PROPERTIES_LANGUAGE_REQUEST =
  'ANALYSIS_PROPERTIES_LANGUAGE_REQUEST'
export const ANALYSIS_PROPERTIES_LANGUAGE_SUCCESS =
  'ANALYSIS_PROPERTIES_LANGUAGE_SUCCESS'
export const ANALYSIS_PROPERTIES_LANGUAGE_FAIL =
  'ANALYSIS_PROPERTIES_LANGUAGE_FAIL'
export const ANALYSIS_PROPERTIES_RESULT_CATEGORY_REQUEST =
  'ANALYSIS_PROPERTIES_RESULT_CATEGORY_REQUEST'
export const ANALYSIS_PROPERTIES_RESULT_CATEGORY_SUCCESS =
  'ANALYSIS_PROPERTIES_RESULT_CATEGORY_SUCCESS'
export const ANALYSIS_PROPERTIES_RESULT_CATEGORY_FAIL =
  'ANALYSIS_PROPERTIES_RESULT_CATEGORY_FAIL'
export const ANALYSIS_PROPERTIES_DESCRIPTION_REQUEST =
  'ANALYSIS_PROPERTIES_DESCRIPTION_REQUEST'
export const ANALYSIS_PROPERTIES_DESCRIPTION_SUCCESS =
  'ANALYSIS_PROPERTIES_DESCRIPTION_SUCCESS'
export const ANALYSIS_PROPERTIES_DESCRIPTION_FAIL =
  'ANALYSIS_PROPERTIES_DESCRIPTION_FAIL'

export const ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_REQUEST =
  'ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_REQUEST'
export const ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_SUCCESS =
  'ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_SUCCESS'
export const ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_FAIL =
  'ANALYSIS_PROPERTIES_DESCRIPTION_TOP10_FAIL'
export const ANALYSIS_PROPERTIES_PATCH_REQUEST =
  'ANALYSIS_PROPERTIES_PATCH_REQUEST'
export const ANALYSIS_PROPERTIES_PATCH_SUCCESS =
  'ANALYSIS_PROPERTIES_PATCH_SUCCESS'
export const ANALYSIS_PROPERTIES_PATCH_FAIL = 'ANALYSIS_PROPERTIES_PATCH_FAIL'
export const ANALYSIS_PROPERTIES_USER_ENTITIES_REQUEST =
  'ANALYSIS_PROPERTIES_USER_ENTITIES_REQUEST'
export const ANALYSIS_PROPERTIES_USER_ENTITIES_SUCCESS =
  'ANALYSIS_PROPERTIES_USER_ENTITIES_SUCCESS'
export const ANALYSIS_PROPERTIES_USER_ENTITIES_FAIL =
  'ANALYSIS_PROPERTIES_USER_ENTITIES_FAIL'
export const ANALYSIS_PROPERTIES_LOCATION_REQUEST =
  'ANALYSIS_PROPERTIES_LOCATION_REQUEST'
export const ANALYSIS_PROPERTIES_LOCATION_SUCCESS =
  'ANALYSIS_PROPERTIES_LOCATION_SUCCESS'
export const ANALYSIS_PROPERTIES_LOCATION_FAIL =
  'ANALYSIS_PROPERTIES_LOCATION_FAIL'
export const ANALYSIS_PROPERTIES_USER_REQUEST =
  'ANALYSIS_PROPERTIES_USER_REQUEST'
export const ANALYSIS_PROPERTIES_USER_SUCCESS =
  'ANALYSIS_PROPERTIES_USER_SUCCESS'
export const ANALYSIS_PROPERTIES_USER_FAIL = 'ANALYSIS_PROPERTIES_USER_FAIL'
export const ANALYSIS_PROPERTIES_DEPARTMENT_REQUEST =
  'ANALYSIS_PROPERTIES_DEPARTMENT_REQUEST'
export const ANALYSIS_PROPERTIES_DEPARTMENT_SUCCESS =
  'ANALYSIS_PROPERTIES_DEPARTMENT_SUCCESS'
export const ANALYSIS_PROPERTIES_DEPARTMENT_FAIL =
  'ANALYSIS_PROPERTIES_DEPARTMENT_FAIL'
export const ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST =
  'ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_REQUEST'
export const ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS =
  'ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_SUCCESS'
export const ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL =
  'ANALYSIS_PROPERTIES_SUBMIT_USER_ENTITIES_FAIL'
export const ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST =
  'ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_REQUEST'
export const ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS =
  'ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_SUCCESS'
export const ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_FAIL =
  'ANALYSIS_PROPERTIES_DETAIL_USER_ENTITIES_FAIL'
